import { Component, inject } from '@angular/core';
import { ToastMessageService } from '../../services/toast-message.service';
import { NgbToast } from '@ng-bootstrap/ng-bootstrap';
import { JsonPipe } from '@angular/common';

@Component({
  selector: 'app-toast-message-container',
  imports: [NgbToast],
  templateUrl: './toast-message-container.html',
  styleUrl: './toast-message-container.scss',
})
export class ToastMessageContainer {
readonly toastService = inject(ToastMessageService);
}
